import { Injectable } from '@angular/core';
import { ConfigService } from '@icc/shared/config.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {


  constructor(
    private configService: ConfigService,
  ) {
  }

  public getLicense(companyId:number): boolean {
    return +this.configService.config.userData?.user?.ActiveCompany === +companyId ? this.configService.config.userData?.user?.ActiveCompanyLicenseType === 'license' : true;
  }

}
